import "./styles.css";

import { ArrowForwardIosRounded, ArrowForwardRounded, ArrowRightRounded, ChevronRightRounded } from "@material-ui/icons";

export default function ButtonLinear({ config, onClick, type, disabled, className }) {

    if (config?.redirect && typeof config.redirect === 'string') {
        try {
            const currentUrl = new URL(window.location.href);
            let redirectStr = config.redirect;

            if (redirectStr.includes("[COUPON]")) {
                redirectStr = redirectStr.replace('[COUPON]', '');
            }

            // Using window.location.origin as base gracefully handles relative URLs
            const targetUrl = new URL(redirectStr, window.location.origin);

            // Append all search params from current page
            currentUrl.searchParams.forEach((value, key) => {
                targetUrl.searchParams.set(key, value);
            });

            config.redirect = targetUrl.toString();
        } catch (e) {
            console.error("Failed to process redirect URL in ButtonLinear:", e);
        }
    }

    const Component = config?.redirect ? 'a' : 'button';

    return (
        <Component
            href={config?.redirect ? config.redirect : undefined}
            onClick={onClick}
            type={type}
            disabled={disabled}
            className={`button-linear ${config?.variant || ''} ${className || ''}`}
            style={{ ...(config?.style || {}) }}
        >
            <span className={"button-linear-content " + (config?.variant || '')}>
                <p><span style={{
                    color: (config?.textColor || 'white')
                }}>{config?.text}</span></p>
            </span>

            <ArrowRightRounded className="button-linear-icon" style={{
                color: config?.textColor || 'white'
            }} />
            <span className="button-glass-badge"></span>
        </Component>
    );
}